<template>
  <div>
    <div class="ajFlex c-page-top">
      <div class="c-page-title">添加系统用户</div>
      <Button type="info" ghost @click="handleBack">返回</Button>
    </div>
    <div class="form-list form-wrapper">
      <Button
        class="long-addBtn"
        size="large"
        long
        type="dashed"
        :loading="loading"
        @click="handleSubmit('formInline')"
        >确认提交</Button
      >
      <Form
        ref="formInline"
        :model="formInline"
        :rules="ruleInline"
        inline
        :label-width="150"
        label-position="right"
      >
        <div v-if="id">
          <Row :gutter="24">
            <Col span="12">
              <FormItem label="用户类型：" prop="userType">
                <Select
                  v-model="formInline.userType"
                  @on-change="handleRole(formInline.userType)"
                  disabled
                  placeholder="默认主管部门"
                >
                  <Option value="tenant">主管部门</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="24">
            <Col span="12">
              <FormItem label="登录用户名：" prop="account">
                <Input
                  v-model="formInline.account"
                  type="tel"
                  placeholder="请输入手机号"
                  disabled
                ></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="用户姓名：" prop="username">
                <Input
                  v-model="formInline.username"
                  placeholder="请输入用户姓名"
                  disabled
                ></Input>
              </FormItem>
            </Col>
            <!--<Col span="12">-->
            <!--<FormItem label="行政区划：" prop="tenantAreaCode">-->
            <!--&lt;!&ndash;<Select v-model="formInline.tenantAreaCode"&ndash;&gt;-->
            <!--&lt;!&ndash;clearable transfer&ndash;&gt;-->
            <!--&lt;!&ndash;placeholder="请选择行政区划">&ndash;&gt;-->
            <!--&lt;!&ndash;<Option v-for="(item,index) in area" :value="item.value" :key="index">{{ item.label }}</Option>&ndash;&gt;-->
            <!--&lt;!&ndash;</Select>&ndash;&gt;-->
            <!--<Cascader :clearable="false" :data="citys"-->
            <!--@on-change="handleDept"-->
            <!--v-model="formInline.tenantAreaCodeS" placeholder="请选择"></Cascader>-->
            <!--</FormItem>-->
            <!--</Col>-->
            <Col span="12">
              <FormItem label="部门：" prop="deptName">
                <Input
                  readonly
                  v-model="formInline.deptName"
                  placeholder="自动匹配"
                  disabled
                ></Input>
              </FormItem>
            </Col>
            <!--<Col span="12">-->
            <!--<FormItem label="处室/机构：" prop="tenantId">-->
            <!--<Select v-model="formInline.tenantId" placeholder="请选择" >-->
            <!--<Option v-for="(item,index) in TenantList" :value="item.id" :key="index">{{ item.name }}</Option>-->
            <!--</Select>-->
            <!--</FormItem>-->
            <!--</Col>-->
            <Col span="12">
              <FormItem label="用户角色：" prop="roleId">
                <Select v-model="formInline.roleId" placeholder="请选择">
                  <Option
                    v-for="(item, index) in roles[formInline.userType]"
                    :value="item.id"
                    :key="index"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>
        </div>
        <div v-else>
          <Row :gutter="24">
            <Col span="12">
              <FormItem label="用户类型：" prop="userType">
                <Select
                  v-model="formInline.userType"
                  @on-change="handleRole(formInline.userType)"
                  placeholder="默认主管部门"
                >
                  <Option value="tenant">主管部门</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="24">
            <Col span="12">
              <FormItem label="登录用户名：" prop="account">
                <Input
                  v-model="formInline.account"
                  type="tel"
                  placeholder="请输入手机号"
                ></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="用户姓名：" prop="name">
                <Input
                  v-model="formInline.name"
                  placeholder="请输入用户姓名"
                ></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="密码：" prop="password">
                <Input
                  v-model="formInline.password"
                  placeholder="请输入密码"
                ></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="确认密码：" prop="passwdCheck">
                <Input
                  v-model="formInline.passwdCheck"
                  placeholder="请输入确认密码"
                ></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="行政区划1111：" prop="tenantAreaCodeS">
                <!--<Select v-model="formInline.tenantAreaCode"-->
                <!--clearable transfer-->
                <!--label-in-value-->
                <!--@on-change="handleDept"-->
                <!--placeholder="请选择行政区划">-->
                <!--<Option v-for="(item,index) in area" :value="item.value" :key="index">{{ item.label }}</Option>-->
                <!--</Select>-->
                <Cascader
                  :clearable="false"
                  :data="citys"
                  @on-change="handleDept"
                  v-model="formInline.tenantAreaCodeS"
                  placeholder="请选择"
                ></Cascader>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="部门：" prop="deptName">
                <Input
                  v-model="formInline.deptName"
                  readonly
                  placeholder="自动匹配"
                ></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="处室/机构：" prop="tenantId">
                <Select v-model="formInline.tenantId" placeholder="请选择">
                  <Option
                    v-for="(item, index) in TenantList"
                    :value="item.id"
                    :key="index"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="用户角色：" prop="roleId">
                <Select v-model="formInline.roleId" placeholder="请选择">
                  <Option
                    v-for="(item, index) in roles[formInline.userType]"
                    :value="item.id"
                    :key="index"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="添加人：" prop="createrName">
                <Input
                  readonly
                  v-model="formInline.createrName"
                  placeholder="系统自动生成"
                ></Input>
              </FormItem>
            </Col>
          </Row>
        </div>
      </Form>
    </div>
  </div>
</template>
<style></style>
<script>
import { mapState } from "vuex";
let phoneReg = /^1(3|4|5|6|7|8|9)\d{9}$/;
export default {
  data() {
    const validateLogin = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请填写用户名!"));
      } else {
        if (value === this.old_loginName) {
          callback();
        } else {
          this.axios({
            method: "post",
            url: "/user/checkUser",
            data: {
              account: value,
              id: this.formInline.id,
            },
          }).then((response) => {
            if (response.data.data) {
              callback(new Error("用户已经存在!"));
            } else {
              callback();
            }
          });
        }
      }
    };
    const validatePass = (rule, value, callback) => {
      let reg = /^.{6,18}$/;
      if (value === "") {
        callback(new Error("请输入密码!"));
      } else {
        if (reg.test(value)) {
          if (this.formInline.passwdCheck !== "") {
            // 对第二个密码框单独验证
            this.$refs.formInline.validateField("passwdCheck");
          }
          callback();
        } else {
          callback("密码必须6-18位");
        }
      }
    };
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认密码!"));
      } else if (value !== this.formInline.password) {
        callback(new Error("两次密码输入不一致!"));
      } else {
        callback();
      }
    };
    return {
      id: "",
      userType: "",
      old_loginName: "",
      // 处室机构
      TenantList: [],
      roles: {
        tenant: [],
        sublet: [],
        project: [],
      },
      loading: false,
      formInline: {
        // 主管
        userType: "tenant",
        account: "",
        name: "",
        password: "",
        passwdCheck: "",
        tenantAreaCodeS: [],
        tenantAreaCode: "",
        tenantAreaName: "",
        deptName: "",
        tenantId: "",
        roleId: "",
        createrName: "",
        // createTime:'',
      },
      ruleInline: {
        // userType: [
        //     { required: true,  message: '用户类型不能为空', trigger: 'change' }
        // ],
        // account: [
        //     { required: true, validator: validateLogin, trigger: 'blur' },
        //     { pattern: /^1(3|4|5|6|7|8|9)\d{9}$/, message: '手机号不正确', trigger: 'change' },
        // ],
        // name: [
        //     { required: true,  message: '用户姓名不能为空', trigger: 'blur' }
        // ],
        // password: [
        //     { required: true,validator: validatePass, trigger: 'blur' }
        // ],
        // passwdCheck: [
        //     { required: true, validator: validatePassCheck, trigger: 'blur' }
        // ],
        // tenantAreaCodeS: [
        //     { required: true, type:'array', min: 1, message: '行政区划不能为空', trigger: 'change' }
        // ],
        // deptName: [
        //     { required: true,  message: '部门不能为空', trigger: 'blur' }
        // ],
        // tenantId: [
        //     { required: true, type:'number',  message: '处室/机构不能为空', trigger: 'change' }
        // ],
        roleId: [
          {
            required: true,
            type: "number",
            message: "用户角色不能为空",
            trigger: "change",
          },
        ],
        // corpName: [
        //     { required: true, type:'string',  message: '企业名称不能为空', trigger: 'blur' }
        // ],
        // linkPerson: [
        //     { required: true, type:'string',  message: '联系人不能为空', trigger: 'blur' }
        // ],
        // linkPersonTel: [
        //     { required: true, type:'string',  message: '联系电话不能为空', trigger: 'blur' }
        // ],
        // idCardNumber: [
        //     { required: true, type:'string',  message: '身份证号不能为空', trigger: 'blur' }
        // ],
      },
    };
  },
  computed: {
    ...mapState(["citys", "users"]),
  },
  created() {
    this.id = this.$route.query.id;
    this.userType = this.$route.query.userType;
    this.formInline.createrName = this.users.userName;
    this.handleRole(this.formInline.userType);
    this.getPageData();
  },
  watch: {},
  methods: {
    handleDept(value, selectedData) {
      let larr = [];
      let varr = [];
      selectedData.forEach((item) => {
        larr.push(item.label);
        varr.push(item.value);
      });
      this.formInline.tenantAreaCode = varr.join("-");
      this.formInline.tenantAreaName = larr.join("-");
      this.formInline.deptName = larr[larr.length - 1] + "住建局";
    },
    // 用户类型改变 角色改变
    handleRole(type) {
      this.formInline.role = "";
      if (this.roles[type].length === 0) {
        this.axios({
          method: "get",
          url: "/role/getRoles",
          params: {
            loginType: type,
          },
        }).then((response) => {
          if (response.data.success) {
            this.roles[type] = response.data.data;
          }
        });
      }
    },
    /* 获取页面信息 */
    getPageData() {
      // 获取处室机构
      // this.axios({
      //     method: 'get',
      //     url:'/tenant/getAllTenant',
      // }).then((response)=>{
      //     if(response.data.success){
      //         this.TenantList=response.data.data;
      //     }
      // });
      if (this.id) {
        // 获取页面信息
        this.axios({
          method: "get",
          url: "/user/getUserById",
          params: {
            id: this.id,
            userType: this.userType,
          },
        }).then((response) => {
          if (response.data.success) {
            if (response.data.data.tenantAreaCode) {
              response.data.data.tenantAreaCodeS = response.data.data.tenantAreaCode.split(
                "-"
              );
            }
            this.formInline = response.data.data;
            this.formInline.userType = "tenant";
          }
        });
      }
    },
    handleBack() {
      this.$router.go(-1);
    },
    /*提交*/
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let data = {
            // loginType:localStorage.getItem('loginType'),
            userid: this.id,
            roleId: this.formInline.roleId,
          };
          // Object.assign(data,this.formInline);
          let url = "/user/addUser";
          if (this.id) {
            url = "/user/updateUser";
          }
          this.loading = true;
          this.axios({
            method: "post",
            url: url,
            data: data,
          })
            .then((response) => {
              this.loading = false;
              if (response.data.success) {
                this.$Message.success("提交成功!");
                this.$router.go(-1);
              } else {
                this.$Message.warning(response.data.errorMsg);
              }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          this.$Message.error("表单验证未通过!");
        }
      });
    },
  },
};
</script>
